// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'

import FastClick from 'fastclick'
import VueECharts from 'vue-echarts/components/ECharts.vue'
//wechat debug
// import vConsole from 'vconsole'

import store from './store'
import App from './App'
import Home from './components/HelloFromVux'
import Hello from './components/Hello'

import HomeHead from './components/HomeHead'
import HomeBody from './components/HomeBody'
import DetailHead from './components/DetailHead'
import DetailPrice from './components/DetailPrice'
import DetailQty from './components/DetailQty'
import DetailType from './components/DetailType'
// import DetailBody from './components/DetailBody'
import HomePay from './components/HomePay'
import DetailTest from './components/DetailTest'

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(Vuex)
Vue.http.options.emulateJSON = true
Vue.http.options.emulateHTTP = true

// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
Vue.component('chart', VueECharts)

let _ver = '12'
console.warn(">>> Current Ver:" + _ver)

console.log("__dirname:"+__dirname )

// test case end
const NotFound = { template: '<div>not-found</div>' }

const routes = [
  {
    path: '/hello',
    component: Hello
  },
  {
    path: '/vux',
    component: Home
  },

  { path: '/test', component: DetailTest },
  { path: '/', component: HomeHead ,
    children: [
      { path: 'pay', component: HomePay },
      { path: '', component: HomeBody }
    ]
  },
  { path: '/detail', component: DetailHead,//Parent,
    children: [
      { path: '', component: DetailPrice },
      { path: 'qty', component: DetailQty },
      { path: 'type', component: DetailType }
    ]
   },
  { path: '', redirect: '/' },
  { path: '*', component: NotFound }
]


const router = new VueRouter({
  mode: 'history',
  base: '/real/gzh', // '/real/test' '/real/gzh'
  routes
})

FastClick.attach(document.body)

Vue.use(vuexI18n.plugin, store)

Vue.i18n.set('zh-CN')

/* eslint-disable no-new */
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js